import { useMemo } from "react";
import Link from "next/link";
import classNames from "classnames";
import { I18n } from "@lingui/core";
import { t } from "@lingui/macro";
import styles from "../LoginOrRegisterView.module.scss";

type TabsProps = {
  type: string;
  signInUrl: string;
  registerUrl: string;
  handleLoginClick: () => void;
  handleRegisterClick: () => void;
  i18n: I18n;
};

function Tabs({
  type,
  signInUrl,
  registerUrl,
  handleLoginClick,
  handleRegisterClick,
  i18n,
}: TabsProps): JSX.Element {
  const tabs = useMemo(
    () => [
      { label: t(i18n)`Log in`, path: signInUrl, onClick: handleLoginClick },
      {
        label: t(i18n)`Sign up`,
        path: registerUrl,
        onClick: handleRegisterClick,
      },
    ],
    [signInUrl, registerUrl, i18n, handleRegisterClick, handleLoginClick]
  );

  return (
    <div className={styles.tabs}>
      {tabs.map((tab) => {
        const isActive = tab.path.includes(type || "");
        return (
          <Link
            key={tab.path}
            href={tab.path}
            onClick={tab.onClick}
            className={classNames(styles.tabLink, {
              [styles.active]: isActive,
            })}
            prefetch={false}
            scroll={false}
          >
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
}

export { Tabs };
